import { ChangeDetectorRef, Component, Inject } from '@angular/core';
  import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
  import { SeoImageUploadService } from 'src/app/services/ImageUploadService/seo-image-upload.service';
  import { lastValueFrom } from 'rxjs';
  import { ActivatedRoute, Router } from '@angular/router';
  import { TemplateMasterService } from '../../template-master.service';

  @Component({
  selector: 'app-upload-template-thumbnail',
  templateUrl: './upload-template-thumbnail.component.html',
  styleUrls: ['./upload-template-thumbnail.component.scss']
})
export class UploadTemplateThumbnailComponent {
    selectedFile: File | null = null;
    previewUrl: string | ArrayBuffer | null = null;
    imgLoader = false;
    componentId!: string;
    componentName: string;
  
    constructor(
      private dialogRef: MatDialogRef<UploadTemplateThumbnailComponent>,
      private _seoImageUploadService: SeoImageUploadService,
      private cdr: ChangeDetectorRef,
      public templateMasterService: TemplateMasterService,
       private route: ActivatedRoute,
      private router: Router,
      @Inject(MAT_DIALOG_DATA) public data: { data }
    ) {
      console.log(this.data.data)
       this.componentName = this.route.snapshot.queryParamMap.get('componentName') || '';
       if (this.data.data.image) {
        this.previewUrl = this.data.data.screenShot; // show pre-uploaded image
      }
    }
  
    onFileSelected(event: any) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        const reader = new FileReader();
        reader.onload = () => (this.previewUrl = reader.result);
        reader.readAsDataURL(this.selectedFile);
      }
    }
  
    // async uploadImage() {
    //   if (!this.selectedFile) return;
    //   this.imgLoader = true;
    //   try {
    //     const result = await this._seoImageUploadService.uploadSEOimages(
    //       this.selectedFile,
    //       'Blogs'
    //     ) as { Location: string };
  
    //     const imgUrl = result.Location;
    //     const payload = {
    //       componentId: this.data.data.componentId,
    //       image: imgUrl
    //     };
    //     await lastValueFrom(this.templateMasterService.updateComponent(payload));
    //     this.dialogRef.close(imgUrl);
    //     this.goBack();
    //   } catch (error) {
    //     console.error('❌ Error while uploading/updating image:', error);
    //   } finally {
    //     this.imgLoader = false;
    //   }
    // }
    async uploadImage() {
    this.imgLoader = true;
  
    try {
      let imgUrl = this.data.data.screenShot;
  
      if (this.selectedFile) {
        const result = await this._seoImageUploadService.uploadSEOimages(
          this.selectedFile,
          'Blogs'
        ) as { Location: string };
  
        imgUrl = result.Location;
      }
  
      const payload = {
        ...this.data.data, // keep everything as is
        screenShot: imgUrl     // overwrite only image
      };
  
      await lastValueFrom(this.templateMasterService.createTemplateV4(payload));
      // this.dialogRef.close(imgUrl);
      this.goBack();
      this.dialogRef.close(imgUrl);
    } catch (error) {
      console.error(' Error while uploading/updating image:', error);
    } finally {
      this.imgLoader = false;
    }
  }
    goBack() {
    this.router.navigate(['/master/template/v3-template']);
  }
  
  
    removeImage() {
      this.selectedFile = null;
      this.previewUrl = null;
    }
  
    close() {
      this.dialogRef.close();
    }
  }
  
